import { Injectable, Type } from '@angular/core';

import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { DialogConfig } from '@/app/shared/ui-common/dialog/dialog-data.interface';
import { DialogState } from '@/app/shared/ui-common/dialog/dialog-state.interface';

@Injectable({
  providedIn: 'root',
})
export class DialogHelperService {
  private readonly _initialState: DialogState = {
    opened: false,
  };

  private _dialog = new BehaviorSubject<DialogState>(this._initialState);
  private _afterClosed = new Subject<unknown>();

  public dialog$ = this._dialog.asObservable();

  public open(config: DialogConfig): Observable<boolean> {
    this._dialog.next({ config, opened: true });
    return this._afterClosed.asObservable() as Observable<boolean>;
  }

  public openCustom<T = unknown>(
    component: Type<unknown>,
    data?: Record<string, unknown>,
  ): Observable<T> {
    this._dialog.next({ component, data, opened: true });
    return this._afterClosed.asObservable() as Observable<T>;
  }

  public close<T = boolean>(state: T | boolean = false) {
    this._dialog.next(this._initialState);
    this._afterClosed.next(state);
  }
}
